import { useEffect } from "react";
import { Cluster } from "../../models/Cluster"
import { Form, FormProps, Input } from "antd";
import { Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import ScriptEditor from "../common/ScriptEditor";

const formLayout: FormProps = {
  wrapperCol: {
    xs: 24,
    md: 20
  },
  labelAlign: "left",
  labelCol: {
    xs: 24,
    md: 4,
  }
}

type Props = {
  cluster?: Cluster;
  onSubmit: (values: any) => void;
  onCancel?: () => void;
}

export default function ClusterForm({ cluster, onSubmit, onCancel }: Props) {
  const [form] = Form.useForm();

  useEffect(() => form.setFieldsValue(cluster), [form, cluster]);

  return (
    <Form {...formLayout} className="compact-form" form={form} onFinish={onSubmit}>
      <Modal.Body>
        <Form.Item name="name" label="Name" rules={[{ required: true, message: "Cluster Name is required" }]}>
          <Input placeholder="Cluster Name" />
        </Form.Item>
        <Form.Item name="description" label="Description">
          <Input.TextArea rows={3} placeholder="Cluster Description" />
        </Form.Item>
        <Form.Item name="json" label="Spec">
          <ScriptEditor height={350} />
        </Form.Item>
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        <Button type="button" variant="light" size="sm" className="border" onClick={onCancel}>Close</Button>
        <Button type="submit" variant="success" size="sm">
          <FontAwesomeIcon icon={solid('save')} />
          <span className="ms-2">Save</span>
        </Button>
      </Modal.Footer>
    </Form>
  )
}